var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",attrs:{"color":"primary","dark":""},on:{"":function($event){}}},[_c('v-icon',[_vm._v("mdi-cash-register")]),_vm._v(" "+_vm._s(_vm.$t("cash_register_section.add_cash_register"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }